import React from 'react';
import dayjs from 'dayjs';
// import { BiHome } from 'react-icons/bi';
// import { isEmpty } from 'lodash';

// import Button from 'partial/components/Button';
import { SolidLogo } from 'modules/common/components/AppIconLogo';
import Version from 'partial/components/Version';
import LoginForm from '../forms/LoginForm';

function Landing() {
  // const websiteUrl = process.env.REACT_APP_WEBSITE_URL;

  // const handleRedirectToWebsite = () => {
  //   window.location.assign(websiteUrl);
  // };

  return (
    <div className="h-full flex flex-col bg-gradient-to-t from-primary-700 to-primary-800">
      <div className="h-full flex flex-col bg-center bg-login">
        {/* <div className="absolute top-5 left-5 uppercase">
          {!isEmpty(websiteUrl) && (
            <Button
              icon={BiHome}
              outlineLight
              onClick={handleRedirectToWebsite}
            >
              Back to homepage
            </Button>
          )}
        </div> */}
        <div className="w-full max-w-lg m-auto">
          <div className="flex justify-center mb-6 h-40 relative">
            <SolidLogo />
            <p className="absolute bottom-9 left-60 ml-4 text-xs text-white whitespace-nowrap">
              BILLER PORTAL
            </p>
          </div>
          <div className="m-auto w-full px-14 pb-10 pt-14 rounded-none sm:rounded-3xl bg-white">
            <h1 className="text-center text-2xl mb-6 font-semibold">Login</h1>
            <LoginForm />
          </div>
          <p className="text-white text-xs text-center mt-6">
            &copy; {dayjs().format('YYYY')} DST Biller Portal <Version />
          </p>

          {/* <div className="h-full flex flex-col bg-center bg-primary-600 bg-login">
      <div className="absolute top-5 left-5 uppercase">
        {!isEmpty(websiteUrl) && (
          <Button icon={BiHome} outlineLight onClick={handleRedirectToWebsite}>
            Back to homepage
          </Button>
        )}
      </div>
      <div className="w-full max-w-lg m-auto">
        <div className="flex justify-center mb-6">
          <SolidLogo />
        </div>
        <div className="m-auto w-full px-14 py-10 rounded-none sm:rounded-3xl bg-white">
          <h1 className="text-center text-2xl mb-6">Sign In</h1>
          <LoginForm />
        </div>
      </div> */}
        </div>
      </div>
    </div>
  );
}

Landing.propTypes = {};

export default Landing;
